import React from 'react'
import Header from '../components/Header'
import ContactUs from '../components/ContactUs'
import Footer from '../components/Footer'

const ContactusPage = () => {
  return (
    <>
    <Header/>
    <ContactUs/>
    <Footer/>
    </>
  )
}

export default ContactusPage